import React from 'react';
import { IconButton, Link, Stack, Tooltip, useTheme } from '@mui/material';

interface FooterSocialsProps {
  socialLinks: Array<{ name: string; icon: React.ReactNode; href: string; color?: string }>;
}

export const FooterSocials = ({ socialLinks }: FooterSocialsProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const renderSocialItem = (social: (typeof socialLinks)[0]) => {
    const brandColor =
      social.name === 'X'
        ? isDark
          ? '#FFFFFF'
          : '#000000'
        : social.color || theme.palette.primary.main;

    return (
      <Tooltip key={social.name} title={social.name}>
        <IconButton
          component={Link}
          href={social.href}
          target="_blank"
          rel="noopener noreferrer"
          size="small"
          sx={{
            color: 'text.secondary',
            bgcolor: 'background.subtle',
            '&:hover': {
              color: brandColor,
              bgcolor: 'background.paper',
              transform: 'translateY(-3px)',
              boxShadow: `0 4px 12px ${isDark ? 'rgba(0,0,0,0.4)' : 'rgba(0,0,0,0.1)'}`,
            },
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            p: 1,
          }}
        >
          {React.cloneElement(social.icon as React.ReactElement, { sx: { fontSize: 20 } })}
        </IconButton>
      </Tooltip>
    );
  };

  const filteredSocialLinks = socialLinks.filter((social) => social.href && social.href !== '#');

  const renderedSocialsList = filteredSocialLinks.map(renderSocialItem);

  return (
    <Stack direction="row" spacing={1.5}>
      {renderedSocialsList}
    </Stack>
  );
};
